import React from 'react';
import SVG from "react-inlinesvg";
import {Modal} from "react-bootstrap";
import {toAbsoluteUrl} from "../../../../../../../_metronic/_helpers";
import {NavLink} from 'react-router-dom';
import {diffCheck, formatAmount, formatDate} from '../../../../../../util/Helpers';
import ErrorMessage from './ErrorMessage';

const TransactionAction = ({show, action: {action, error, data}, onHide}) => {
    

    return <Modal
        show={show}
        onHide={onHide}
        aria-labelledby="contained-modal-title-vcenter"
    >
        <Modal.Header>
            <Modal.Title id="contained-modal-title-vcenter">
                <span className={`svg-icon svg-icon-lg svg-icon-danger mr-3`}>
                    <SVG
                        title=""
                        src={toAbsoluteUrl("/media/svg/icons/Shopping/Cart3.svg")}
                    />
                </span> {action}
            </Modal.Title>
            <button type="button" className="close" onClick={onHide}>
                <span aria-hidden="true" className="d-block">×</span>
                <span className="sr-only">Close</span>
            </button>
        </Modal.Header>
        <Modal.Body>
            <ErrorMessage {...{error}} />
           <div className="px-md-5">
                <div className="row">
                    <div className="col-md-4 h6">
                        User
                    </div>
                    <div className="col-md h6 text-muted">
                        <NavLink to={`/users/view/${data?.userId}`} target="_blank">
                            {data?.username ?? ""}
                        </NavLink>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4 h6">
                        Email
                    </div>
                    <div className="col-md h6 text-muted">
                        {data?.meta?.email}
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4 h6">
                     Amount
                    </div>
                    <div className="col-md h6 text-muted">
                        <NavLink
                            to={`/users/view/${data?.meta?.userId}/account-information/${data?.accountId}`}
                            className="text-muted text-hover-primary" target="_blank">
                            {data?.tranAmount}
                        </NavLink>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4 h6">
                        Currency
                    </div>
                    <div className="col-md h6 text-muted">
                        {data?.meta?.currency}
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4 h6">
                        Comment
                    </div>
                    <div className="col-md h6 text-muted">
                        {data?.comment}
                    </div>
                </div>
               
                <div className="row mt-4">
                    <div className="col-md-4 h6">
                        Type
                    </div>
                    <div className="col-md h6 text-muted">
                        {data?.transactionType}
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4 h6">
                        Status
                    </div>
                    <div className="col-md h6 text-muted">
                        {diffCheck(data.meta.status, data?.status)}
                    </div>
                </div>
               
                <div className="row mt-4">
                    <div className="col-md-4 h6">
                        Date
                    </div>
                    <div className="col-md h6 text-muted">
                        {formatDate( data?.meta?.updated)}
                    </div>
                </div>
            </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
            <button
                type="button"
                onClick={onHide}
                className="btn btn-primary btn-elevate px-5"
            >
                Okay
            </button>
        </Modal.Footer>
    </Modal>
}

export default TransactionAction;